<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <!-- ========================================== PC ============================================== -->
    <div v-if="this.verticalNavMenuWidth === 'default'" class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <!--        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />-->

        <!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->

        <!--<vs-button class="px-3 mr-3" color="primary" type="border" @click="openLink">{{ $t('현장 센서 모니터링') }}</vs-button>-->

        <!--        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="UserIcon" @click.stop="handleUserIcon" />-->

        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />

        <label class="proj-name">{{ projectName }}</label>
        <vs-spacer />

        <!--<search-bar class="mr-4" />-->

        <i18n-drop-down/>

        <notification-drop-down />

        <profile-drop-down />
      </vs-navbar>
    </div>
    <!-- ========================================== MOBILE ============================================== -->
    <div v-else class="" :class="classObj">
      <div v-if="$route.meta.topBanner" class="m-top-banner">
        <div class="m-top-banner-contents">
          <!-- Logo -->
          <router-link tag="div" class="pl-2 vx-logo cursor-pointer flex items-center" to="/home">
            <img v-if="hostname === 'ep.maot.co.kr'" class="fill-current" src="@/assets/images/logo/ep-logo2.svg" style="height: 40px" />
            <img v-else-if="hostname === 'dgjg.maot.co.kr'" class="fill-current" src="@/assets/images/logo/snb-dgjg.svg" style="height: 40px" />
            <img v-else-if="hostname === 'gsnd.maot.co.kr'" class="fill-current" src="@/assets/images/logo/snb_gsnd.svg" style="height: 40px" />
            <img v-else-if="hostname === 'bsgs.maot.co.kr'" class="fill-current" src="@/assets/images/logo/snb_bsgs.svg" style="height: 35px" />
            <img v-else-if="hostname === 'gjng.maot.co.kr'" class="fill-current" src="@/assets/images/logo/snb_gjng.svg" style="height: 40px" />
            <img v-else-if="hostname === 'gdco.maot.co.kr'" class="fill-current" src="@/assets/images/logo/snb_gdco.svg" style="height: 40px" />
            <img v-else-if="hostname === 'publicdemo.maot.co.kr'" class="fill-current" src="@/assets/images/logo/public-logo.svg" style="height: 40px" />
            <img v-else-if="hostname === 'kangwonlanddemo.maot.co.kr'" class="fill-current" src="@/assets/images/logo/snb_kangwonland.svg" style="height: 40px" />
            <img v-else-if="hostname === 'premium.maot.co.kr'" class="fill-current" src="@/assets/images/logo/SNB_Premuim.svg" />
            <img v-else-if="hostname === 's1.maot.co.kr'" class="fill-current" src="@/assets/images/logo/s1_SNB.svg" />
            <img v-else-if="hostname === 'dbm.maot.co.kr'" class="fill-current" src="@/assets/images/logo/MAOT_DB_Management_System_snb.svg" />
            <img v-else-if="hostname === 'shmusc.maot.co.kr'" class="fill-current" src="@/assets/images/logo/shm_logo_SNB.svg" />
            <img v-else class="fill-current" src="@/assets/images/logo/shm_logo_SNB.svg" />
          </router-link>
          <!-- /Logo -->
          <profile-drop-down />
        </div>
      </div>
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
        <label class="proj-name">{{ projectName }}</label>
        <!-- <vs-spacer /> -->


        <top-tool-drop-down />

<!--        <feather-icon class="sm:inline-flex cursor-pointer p-2" icon="HomeIcon" @click.stop="handleHomeIcon" />-->
        <notification-drop-down />
      </vs-navbar>
    </div>

    <div class="absolute py-3" style="top:5.5rem; right:2.2rem; z-index: 41001;">

      <transition-group name="fade-bottom" tag="div">
        <div v-for="(item, i) in visibleAlerts" :key="`긴급공지_${item.post_id_idx}`"
             class="p-4 mb-4 bg-white relative overflow-hidden" style="box-shadow: 0 2px 8px 0 #00000021; border-radius: 8px;">
          <!-- 알림 내용 -->
          <div class="flex gap-2 items-center">
            <span v-if="item.alertType === '긴급'" class="py-2 px-3 gap-1 rounded-lg font-bold text-base text-white flex items-center" style="background: #E71825">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0001 2.84375V5.64062M5.31421 6.95474L3 4.84375M18.6859 6.95474L21 4.84375" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.99206 21.1551H20.008C20.6153 21.1551 20.919 21.1551 21.1217 21.0284C21.2992 20.9174 21.4285 20.7437 21.4837 20.5418C21.5469 20.3112 21.4596 20.0204 21.2851 19.4386L20.6359 17.2746C20.5425 16.9632 20.4957 16.8075 20.4073 16.6893C20.3105 16.5598 20.1781 16.4614 20.0263 16.4058C19.8876 16.3551 19.7251 16.3551 19.4 16.3551H4.60001C4.27492 16.3551 4.11238 16.3551 3.97371 16.4058C3.82191 16.4614 3.68954 16.5598 3.59272 16.6893C3.50428 16.8075 3.45757 16.9632 3.36416 17.2746L2.71495 19.4386C2.54043 20.0204 2.45317 20.3112 2.51628 20.5418C2.57156 20.7437 2.70081 20.9174 2.87832 21.0284C3.08101 21.1551 3.38469 21.1551 3.99206 21.1551Z" fill="white"/>
                <path d="M18.8134 12.6677C19.0059 13.3093 18.5263 13.9551 17.8565 13.9551C16.3397 13.9551 13.8432 13.9551 11.9996 13.9551C10.156 13.9551 7.65954 13.9551 6.14277 13.9551C5.47291 13.9551 4.99334 13.3093 5.18583 12.6677L6.38583 8.66773C6.51272 8.24475 6.90205 7.95508 7.34365 7.95508H16.6556C17.0972 7.95508 17.4865 8.24475 17.6134 8.66773L18.8134 12.6677Z" fill="white"/>
              </svg>
              <span v-if="isKorean">{{ $t('긴급') }}</span>
            </span>
            <span v-if="item.alertType === '안전'" class="py-2 px-3 gap-1 rounded-lg font-bold text-base text-white flex items-center bg-success">
              <feather-icon icon="ShieldIcon" stroke="white" stroke-width="2" />
              <span v-if="isKorean">{{ $t('안전') }}</span>
            </span>
            <span v-if="item.alertType === '안내'" class="py-2 px-3 gap-1 rounded-lg font-bold text-base text-white flex items-center" style="background: #3b82f6">
              <feather-icon icon="InfoIcon" stroke="white" stroke-width="2" />
              <span v-if="isKorean">{{ $t('안내') }}</span>
            </span>
            <span class="mr-auto font-bold text-lg" style="max-width: 280px; min-width: 180px;">{{ item.message }}</span>
            <!-- 자세히보기 버튼 (이동 아이콘) -->
            <a :href="`/project/${item.project_id_idx}/tab/${item.board_id_idx}/write/${item.post_id_idx}`"
               class="flex items-center justify-center w-8 h-8 rounded hover:bg-gray-100 transition-colors"
               :title="$t('자세히보기')">
              <feather-icon icon="ExternalLinkIcon" size="18" />
            </a>
            <!-- X 버튼 (긴급 알림이 아닐 때만 표시) -->
            <button v-if="item.alertType !== '긴급'"
                    @click="removeAlert(item.post_id_idx)"
                    class="flex items-center justify-center w-8 h-8 rounded hover:bg-gray-100 transition-colors ml-1 cursor-pointer"
                    :title="$t('알림 닫기')">
              <feather-icon icon="XIcon" size="18" />
            </button>
          </div>
          <!-- 진행 바 (긴급 알림이 아닐 때만 표시) -->
          <div v-if="item.alertType !== '긴급'" class="absolute bottom-0 left-0 w-full h-1 bg-gray-200 rounded-b-lg overflow-hidden">
            <div class="h-full alert-progress-bar"
                 :style="{
                   backgroundColor: item.alertType === '안전' ? '#10b981' : '#3b82f6',
                   animationDuration: `${item.duration}s`,
                   animationDelay: '0s'
                 }"></div>
          </div>
        </div>
      </transition-group>

    </div>
  </div>
</template>

<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";
import I18nDropDown from "./components/I18n.vue";
import config from "/public/config";
import TopToolDropDown from "@/layouts/components/navbar/components/TopToolDropDown.vue";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
    isSideMenu: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TopToolDropDown,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    I18nDropDown,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return { "text-white": (this.navbarColor !== "#10163a" && this.$store.state.theme === "dark") || (this.navbarColor !== "#fff" && this.$store.state.theme !== "dark") };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    projectName() {
      if (this.projectId) {
        return this.projectInfo.field_name;
      }
      return "";
    },
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    isKorean() {
      return this.$i18n.locale === 'ko-KR';
    },
    unreadAlert () {
      let readInfo = this.$store.state.approval.mainAlertUnReadInfo;
      if (readInfo) {
        readInfo = JSON.parse(JSON.stringify(this.$store.state.approval.mainAlertUnReadInfo))
        if (readInfo.data && readInfo.data.length > 0) {
          return readInfo.data.filter(item => {
            return item.board_id_idx === 1091;
          }).map((post) => {
            const data = JSON.parse(post.data);
            return {
              alertType: data.alertType,
              message: post.message,
              post_id_idx: post.post_id_idx,
              board_id_idx: post.board_id_idx,
              project_id_idx: post.project_id_idx
            }
          });
        }
      }

      return [];
    },
    visibleAlerts() {
      const alerts = this.unreadAlert.filter(alert => !this.removedAlerts.includes(alert.post_id_idx));
      let nonUrgentIndex = 0;

      return alerts.map(alert => {
        if (alert.alertType === '긴급') {
          return {
            ...alert,
            duration: null // 긴급 알림은 타이머 없음
          };
        } else {
          const duration = this.alertTimeSettings.baseDuration + (nonUrgentIndex * this.alertTimeSettings.incrementPerCard);
          nonUrgentIndex++;
          return {
            ...alert,
            duration: duration
          };
        }
      });
    }
  },
  data() {
    return {
      hostname: config.HOST_NAME,
      selectWorkType: "Coffee",
      removedAlerts: [], // 사용자가 제거한 알림 ID 목록
      alertTimeSettings: {
        baseDuration: 10, // 기본 10초
        incrementPerCard: 1 // 카드마다 +1초
      },
      alertTimers: {} // 각 알림의 타이머를 저장
    };
  },
  async mounted() {
    this.setupAlertTimers();
  },
  watch: {
    unreadAlert: {
      handler(newAlerts, oldAlerts) {
        // 새로운 알림이 추가될 때만 타이머 설정
        if (newAlerts && oldAlerts) {
          const newAlertIds = newAlerts.map(alert => alert.post_id_idx);
          const oldAlertIds = oldAlerts.map(alert => alert.post_id_idx);

          // 새로 추가된 알림에 대해서만 타이머 설정
          const addedAlerts = newAlerts.filter(alert => !oldAlertIds.includes(alert.post_id_idx));
          if (addedAlerts.length > 0) {
            this.setupTimersForNewAlerts(addedAlerts);
          }
        } else if (newAlerts && newAlerts.length > 0) {
          // 초기 로드 시
          this.setupAlertTimers();
        }
      },
      immediate: true
    }
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },

    handleHomeIcon() {
      if (this.projectId) {
        this.$router.push(`/project/${this.projectId}`).catch(() => {});
      } else {
        this.$router.push("/").catch(() => {});
      }
    },

    handleUserIcon() {
      this.$router.push("/mypage/workstatus");
    },


    // 알림 제거 메서드
    removeAlert(postId) {
      this.removedAlerts.push(postId);
      // 해당 알림의 타이머도 정리
      if (this.alertTimers[postId]) {
        clearTimeout(this.alertTimers[postId]);
        delete this.alertTimers[postId];
      }
    },

    // 모든 타이머 정리
    clearAllTimers() {
      Object.values(this.alertTimers).forEach(timer => clearTimeout(timer));
      this.alertTimers = {};
    },

    // 알림 타이머 설정
    setupAlertTimers() {
      const alerts = this.visibleAlerts;

      alerts.forEach((alert) => {
        // 긴급 알림이 아니고 이미 타이머가 설정되어 있지 않은 경우에만 설정
        if (alert.alertType !== '긴급' && alert.duration && !this.alertTimers[alert.post_id_idx]) {
          const duration = alert.duration * 1000; // 이미 계산된 duration 사용

          this.alertTimers[alert.post_id_idx] = setTimeout(() => {
            this.removeAlert(alert.post_id_idx);
          }, duration);
        }
      });
    },

    // 새로 추가된 알림에 대해서만 타이머 설정
    setupTimersForNewAlerts(newAlerts) {
      // visibleAlerts에서 새로 추가된 알림을 찾아서 타이머 설정
      const visibleAlertsMap = this.visibleAlerts.reduce((map, alert) => {
        map[alert.post_id_idx] = alert;
        return map;
      }, {});

      newAlerts.forEach((alert) => {
        const visibleAlert = visibleAlertsMap[alert.post_id_idx];
        // 긴급 알림이 아니고 duration이 있으며 이미 타이머가 설정되어 있지 않은 경우에만 설정
        if (visibleAlert && visibleAlert.alertType !== '긴급' && visibleAlert.duration && !this.alertTimers[alert.post_id_idx]) {
          const duration = visibleAlert.duration * 1000; // 이미 계산된 duration 사용

          this.alertTimers[alert.post_id_idx] = setTimeout(() => {
            this.removeAlert(alert.post_id_idx);
          }, duration);
        }
      });
    }
  },

  beforeDestroy() {
    // 컴포넌트가 파괴될 때 모든 타이머 정리
    this.clearAllTimers();
  }

};
</script>

<style lang="scss" scoped>
.proj-name {
  border-left: 1px solid #dae1e7;
  padding-left: 8px;
  font-size: 18px;
}

.navbar-full {
  header {
    border-radius: 0px;

    label.proj-name {
      flex: 1;
      color: #606060;
      font-weight: 500;
      text-align: center;
      border: none;
      padding: 0;
    }
  }
}

.m-top-banner {
  padding: .8rem 1rem;
  background: #1E0D61;
  color: #fff;
}
.m-top-banner-contents {
  display: flex;
  justify-content: space-between;
}
</style>
